module.exports = __webpack_public_path__ + "4b56432d9b869446c8dfc1294b35edc2.svg";


//////////////////
// WEBPACK FOOTER
// ./customer/assets/image/white-label/gromec/logo-gromec-fr.svg
// module id = 686
// module chunks = 0